module.exports = __webpack_public_path__ + "static/img/rch_white_no_background.e54c8bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/rch_white_no_background.svg
// module id = 25
// module chunks = 4